<template>
  <div class="finance">
    <h4>{{ typeChoice.find(x => x.value === this.paymentType.value).name }}</h4>
    <div v-if="this.loading">
      <div class="d-flex justify-content-center">
        <div class="spinner-grow m-5" role="status">
          <span class="sr-only">Loading...</span>
        </div>
      </div>
    </div>
    <div v-else>
      <div class="row">
        <div class="col-4 pt-2">
          <multiselect
            v-model="paymentType"
            :options="typeChoice"
            track-by="value"
            label="name"
            @input="getNewPaymentType()"
            placeholder="Выберите тип платежа"
            :allow-empty="false">
            <template slot="singleLabel" slot-scope="{ option }">
              {{ option.name }}
            </template>
          </multiselect>
        </div>
        <div class="col-3">
          <div class="form-group">
            <label for="search-name">Поиск по фамилии</label>
            <input class="form-control" id="search-name" v-model="searchName"
                      @input="getFilteredPayments()"
                      @focusin="InputFocusIn('search-name')"
                      @focusout="InputFocusOut('search-name')"/>
          </div>
        </div>
        <div class="col-3">
          <div class="form-group">
            <label for="search-phone">Тел. подписчика</label>
            <input class="form-control" id="search-phone" v-model="searchPhone"
                      @input="getFilteredPayments()"
                      @focusin="InputFocusIn('search-phone')"
                      @focusout="InputFocusOut('search-phone')"/>
          </div>
        </div>
        <div class="col-2">
          <datepicker v-model="fromDate" placeholder="Начало"
                      @input="getNewPaymentType()"
                      :language="ru" input-class="form-control"
                      wrapper-class="form-group"/>
        </div>
      </div>
      <div v-if="this.loadingTableData">
        <div class="d-flex justify-content-center">
          <div class="spinner-grow m-5" role="status">
            <span class="sr-only">Loading...</span>
          </div>
        </div>
      </div>
      <v-payment-table v-else :payments="this.payments.results" @update="getFilteredPayments()"
                       :payment-type="this.paymentType.value"/>
      <v-paginator :data="this.payments" @change="pageCallback" />
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import { ru } from 'vuejs-datepicker/dist/locale';
import Multiselect from 'vue-multiselect';
import VPaymentTable from '../../components/tables/v-payment-table.vue';
import VPaginator from '../../components/layouts/v-paginator.vue';

export default {
  name: 'Finance',
  components: { VPaginator, VPaymentTable, Multiselect },
  data() {
    return {
      typeChoice: [
        { name: 'Входящие платежи', value: 'payment' },
        { name: 'Исходящие платежи', value: 'provider_payment' },
        { name: 'Оплата подписки', value: 'subscription_payment' },
        { name: 'Выплаты дилерам', value: 'dealer_payment' },
        { name: 'Возвраты пользователям', value: 'refund_payment' },
      ],
      paymentType: {},
      ru,
      fromDate: '',
      searchPhone: '',
      searchName: '',
      page: 1,
      loading: true,
      fullPaymentFilter: '',
      payments: {},
      loadingTableData: false,
    };
  },
  computed: {
    ...mapState('payment', [
      'paymentList',
      'providerPaymentList',
      'dealerPaymentList',
      'subscriptionPaymentList',
      'refundPaymentList',
    ]),
  },
  methods: {
    ...mapActions('payment', [
      'getPaymentList',
      'getProviderPaymentList',
      'getDealerPaymentList',
      'getSubscriptionPaymentList',
      'getRefundPaymentList',
    ]),
    pageCallback(pageNum) {
      this.page = pageNum;
      this.getFilteredPayments();
    },
    getNewPaymentType() {
      this.loadingTableData = true;
      this.pageCallback(1);
    },


    getFilteredPayments() {
      this.fullPaymentFilter = `?is_paid=true&page=${this.page}`;
      if (this.searchName) {
        this.fullPaymentFilter += `&last_name=${this.searchName}`;
      }
      if (this.searchPhone) {
        this.fullPaymentFilter += `&contact_phone=${this.searchPhone}`;
      }
      if (this.fromDate) {
        this.fullPaymentFilter += `&begin=${this.fixDateToFilter(this.fromDate)}`;
      }
      if (this.paymentType.value === 'payment') {
        this.getPaymentList(this.fullPaymentFilter)
          .then(() => { this.payments = this.paymentList; })
          .then(() => { this.loading = false; })
          .then(() => { this.loadingTableData = false; });
      }
      if (this.paymentType.value === 'provider_payment') {
        this.getProviderPaymentList(this.fullPaymentFilter)
          .then(() => { this.payments = this.providerPaymentList; })
          .then(() => { this.loadingTableData = false; });
      }
      if (this.paymentType.value === 'subscription_payment') {
        this.getSubscriptionPaymentList(this.fullPaymentFilter)
          .then(() => { this.payments = this.subscriptionPaymentList; })
          .then(() => { this.loadingTableData = false; });
      }
      if (this.paymentType.value === 'dealer_payment') {
        this.getDealerPaymentList(this.fullPaymentFilter)
          .then(() => { this.payments = this.dealerPaymentList; })
          .then(() => { this.loadingTableData = false; });
      }
      if (this.paymentType.value === 'refund_payment') {
        this.getRefundPaymentList(this.fullPaymentFilter)
          .then(() => { this.payments = this.refundPaymentList; })
          .then(() => { this.loadingTableData = false; });
      }
    },
  },
  created() {
    this.paymentType = this.typeChoice.find((x) => x.value === 'payment');
    this.getFilteredPayments();
  },
};
</script>
